import { forwardRef, InputHTMLAttributes, ReactNode } from "react";
import { cva, VariantProps } from "class-variance-authority";

const styles = cva([
  "w-4",
  "h-4",
  "text-blue-500",
  "bg-gray-300",
  "border-gray-300",
  "focus:ring-form-focus",
  "focus:ring-2",
  "focus:ring-offset-1",
]);
type VProps = VariantProps<typeof styles>;

export interface CheckBoxProps
  extends VProps,
    InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  children?: ReactNode;
  "data-testid"?: string;
}

/**
 *
 */
export const CheckBox = forwardRef<HTMLInputElement, CheckBoxProps>(
  function Checkbox(
    { className, "data-testid": dataTestId, ...props }: CheckBoxProps,
    forwardedRef,
  ) {
    const testId = dataTestId || `checkbox-${props.name || "default"}`;

    return (
      <input
        ref={forwardedRef}
        id="inline-checkbox"
        type="checkbox"
        data-testid={testId}
        {...props}
        className={styles({ className })}
      />
    );
  },
);
